var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from "@emotion/react";
import styled from "@emotion/styled";
export var BBox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var defaultBoundingBoxMargin = 10;
export var NodeOverlay = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (_a) {
    var nodeBoundingBoxHeight = _a.nodeBoundingBoxHeight, nodeBoundingBoxMargin = _a.nodeBoundingBoxMargin;
    var boundingBoxMargin = nodeBoundingBoxMargin !== undefined
        ? nodeBoundingBoxMargin
        : defaultBoundingBoxMargin;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\t\ttransform: translate(-50%, -", "px);\n\t\t\tposition: relative;\n\t\t\tpointer-events: all;\n\n\t\t\t", " {\n\t\t\t\theight: ", "px;\n\t\t\t\tmargin: ", "px;\n\t\t\t}\n\t\t"], ["\n\t\t\ttransform: translate(-50%, -", "px);\n\t\t\tposition: relative;\n\t\t\tpointer-events: all;\n\n\t\t\t", " {\n\t\t\t\theight: ", "px;\n\t\t\t\tmargin: ", "px;\n\t\t\t}\n\t\t"])), boundingBoxMargin, BBox, nodeBoundingBoxHeight, boundingBoxMargin);
});
var templateObject_1, templateObject_2, templateObject_3;
